// routes/_app.user-referral.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.user-referral')

export const handle = {
  name: 'user-referral',
  track: { scene: 'user-referral' },
}

export default dynamic(getClientModule, { ssr: false })
